<template>
	<div>
		<div class="mianPage">
			<div class="topSearch">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-date-picker v-model="queryData.submitDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="small"
							placeholder="时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-input clearable v-model="queryData.companyName" size="small"
							placeholder="公司名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-input clearable v-model="queryData.appName" size="small"
							placeholder="应用名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.examineStatus" clearable size="small" placeholder="审核状态">
							<el-option label="待审核" :value="1"></el-option>
							<el-option label="已通过" :value="2"></el-option>
							<el-option label="已驳回" :value="3"></el-option>
							<!-- <el-option label="已停止" :value="4"></el-option> -->
						</el-select>
					</el-form-item>
					<div class="menu-right">
						<el-button @click="searchReset" size="small" v-hasPermi="['approvalPending:applicationQuality:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small"
							v-hasPermi="['approvalPending:applicationQuality:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<div class="approvalList">
				<div v-if="tableData.length>0">
					<div class="approvalBox" v-for="(item,index) in tableData" :key="index">
						<div class="statusTitle space_between">
							<div class="companyTxt">{{item.appName}}</div>
							<div class="statusTxt" v-if="item.examineStatus == 1">待审核</div>
							<div class="statusTxt" v-else-if="item.examineStatus == 2" style="color: #19B21E;">已通过</div>
							<div class="statusTxt" v-else-if="item.examineStatus == 3" style="color: #FC474C;">已驳回</div>
						</div>
						<div class="infoRow flex_start">
							<div class="infoTxt">所属公司：：<span>{{item.companyName}}</span></div>
							<div class="infoTxt">APP名称：<span>{{item.appName}}</span></div>
						</div>
						<div class="infoRow flex_start">
							<div class="infoTxt">APP ID：<span>{{item.appId}}</span></div>
							<div class="infoTxt">OS：<span>{{item.os}}</span></div>
							<div class="infoTxt">应用商店：<span>{{item.appMarket}}</span></div>
							<div class="infoTxt">包名：<span>{{item.packageN}}</span></div>
						</div>
						<div class="infoRow flex_start">
							<div class="infoTxt" style="width: 100%;">应用详情页：<span>{{item.downLink}}</span></div>
						</div>
						<div class="infoRow flex_start" v-if="item.examineStatus == 3">
							<div class="infoTxt" style="width: 100%;">驳回原因：<span style="color: #FC474C;">{{item.cause}}</span></div>
						</div>
						<div class="infoRow space_between" style="margin-bottom: 0;">
							<div class="infoTxt"><span>{{item.submitDate}}</span></div>
							<div>
								<el-button type="primary" size="small" plain @click="showApprovalHistory(item)"
								v-hasPermi="['approvalPending:applicationQuality:approval']">审批历史</el-button>
								<el-button type="primary" size="small" plain @click="showApprovalInfo(item)"
								v-hasPermi="['approvalPending:applicationQuality:approval']">查看详情</el-button>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="emptyBox">
					<el-empty description="暂无更多"></el-empty>
				</div>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="审批详情" class="el_dialogs" :visible.sync="auditInfoDialogVisible" width="40%" @close="closeauditInfoDialog">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="rulesApi" :model="auditInfoDialogFormData"
				ref="ruleForm">
				<div class="approvalTopRow space_between">
					<div>
						<div class="approvalTitle">{{auditInfoDialogFormData.appName}}</div>
						<div class="approvalTips">提交时间：{{auditInfoDialogFormData.submitDate}}</div>
					</div>
					<div class="statusTxt" v-if="auditInfoDialogFormData.examineStatus == 1">待审核</div>
					<div class="statusTxt" v-else-if="auditInfoDialogFormData.examineStatus == 2" style="color: #19B21E;">已通过</div>
					<div class="statusTxt" v-else-if="auditInfoDialogFormData.examineStatus == 3" style="color: #FC474C;">已驳回</div>
				</div>
				<div class="dialogSplit"></div>
				<div class="dialogContBox">
					<div class="approvalTips">所属公司</div>
					<div class="approvalCont">{{auditInfoDialogFormData.companyName}}</div>
					<div class="approvalTips">APP名称</div>
					<div class="approvalCont">{{auditInfoDialogFormData.appName}}</div>
					<div class="approvalTips">APP ID</div>
					<div class="approvalCont">{{auditInfoDialogFormData.appId}}</div>
					<div class="approvalTips">OS</div>
					<div class="approvalCont">{{auditInfoDialogFormData.os}}</div>
					<div class="approvalTips">应用商店</div>
					<div class="approvalCont">{{auditInfoDialogFormData.appMarket}}</div>
					<div class="approvalTips">应用详情页</div>
					<div class="approvalCont">{{auditInfoDialogFormData.downLink}}</div>
					<div class="approvalTips" v-if="auditInfoDialogFormData.os != 'IOS'">SHA1值</div>
					<div class="approvalCont" v-if="auditInfoDialogFormData.os != 'IOS'">{{auditInfoDialogFormData.sha1}}</div>
					<div class="approvalTips" v-if="auditInfoDialogFormData.os != 'IOS'">程序主包名</div>
					<div class="approvalTips" v-else>Bundle ID</div>
					<div class="approvalCont">{{auditInfoDialogFormData.packageN}}</div>
					<div class="approvalTips">开发者类型</div>
					<div class="approvalCont" v-if="auditInfoDialogFormData.developerType==1">应用开发者</div>
					<div class="approvalCont" v-else-if="auditInfoDialogFormData.developerType==2">与应用开发者存在主体关联关系</div>
					<div class="approvalCont" v-else-if="auditInfoDialogFormData.developerType==3">其他</div>
					<div class="approvalTips">应用资质</div>
					<div v-if="auditInfoDialogFormData.certificationUrl && auditInfoDialogFormData.certificationUrl.length>0">
						<div class="fileCont flex_start" v-for="(item,index) in auditInfoDialogFormData.certificationUrl"
						@click="downloadFile(item)">
							<img src="../../assets/icon/approvalIcon.png" alt="" class="fileIcon" />
							<div class="fileName">{{item}}</div>
						</div>
					</div>
					<div class="approvalTips">其他资质</div>
					<div v-if="auditInfoDialogFormData.otherCertificationUrl && auditInfoDialogFormData.otherCertificationUrl.length>0">
						<div class="fileCont flex_start" v-for="(item,index) in auditInfoDialogFormData.otherCertificationUrl"
						@click="downloadFile(item)">
							<img src="../../assets/icon/approvalIcon.png" alt="" class="fileIcon" />
							<div class="fileName">{{item}}</div>
						</div>
					</div>
					<div class="approvalTips">ICP备案</div>
					<div class="approvalCont">{{auditInfoDialogFormData.icp}}</div>
					<div v-if="auditInfoDialogFormData.examineStatus == 3">
						<div class="approvalTips">驳回原因</div>
						<div class="approvalCont" style="color: #FC474C;">{{auditInfoDialogFormData.cause}}</div>
					</div>
				</div>
				<div class="dialogSplit"></div>
				<div class="approvalDialogBottom flex_end" v-if="auditInfoDialogFormData.examineStatus == 1">
					<el-button type="primary" plain @click="approvalOperation(3)" size="medium">驳回</el-button>
					<el-button type="primary" @click="approvalOperation(2)" size="medium">通过</el-button>
				</div>
				<div class="approvalDialogBottom flex_end" v-else>
					<el-button type="primary" @click="closeauditInfoDialog" size="medium">关闭</el-button>
				</div>
			</el-form>
		</el-dialog>
		<el-dialog title="审批历史" class="el_dialogs" :visible.sync="auditHistoryVisible" width="70%" @close="closeAuditHistoryDialog">
			<div class="approvalLists" v-if="historyData.length>0">
				<div class="approvalBox" v-for="(item,index) in historyData" :key="index">
					<div class="statusTitle space_between">
						<div class="companyTxt">{{item.appName}}</div>
						<div class="statusTxt" v-if="item.examineStatus == 1">待审核</div>
						<div class="statusTxt" v-else-if="item.examineStatus == 2" style="color: #19B21E;">已通过</div>
						<div class="statusTxt" v-else-if="item.examineStatus == 3" style="color: #FC474C;">已驳回</div>
					</div>
					<div class="infoRow flex_start">
						<div class="infoTxt">所属公司：：<span>{{item.companyName}}</span></div>
						<div class="infoTxt">APP名称：<span>{{item.appName}}</span></div>
					</div>
					<div class="infoRow flex_start">
						<div class="infoTxt">APP ID：<span>{{item.appId}}</span></div>
						<div class="infoTxt">OS：<span>{{item.os}}</span></div>
						<div class="infoTxt">应用商店：<span>{{item.appMarket}}</span></div>
						<div class="infoTxt">包名：<span>{{item.packageN}}</span></div>
					</div>
					<div class="infoRow flex_start">
						<div class="infoTxt" style="width: 100%;">应用详情页：<span>{{item.downLink}}</span></div>
					</div>
					<div class="infoRow flex_start" v-if="item.examineStatus == 3">
						<div class="infoTxt" style="width: 100%;">驳回原因：<span style="color: #FC474C;">{{item.cause}}</span></div>
					</div>
					<div class="infoRow space_between" style="margin-bottom: 0;">
						<div class="infoTxt"><span>{{item.submitDate}}</span></div>
						<div>
							<el-button type="primary" size="small" plain @click="showApprovalInfo(item)"
							v-hasPermi="['approvalPending:applicationQuality:approval']">查看详情</el-button>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="emptyBox">
				<el-empty description="暂无更多"></el-empty>
			</div>
			<div class="dialogSplit"></div>
			<div class="approvalDialogBottom flex_end">
				<el-button type="primary" size="medium" @click="closeAuditHistoryDialog">关闭</el-button>
			</div>
		</el-dialog>
		<el-dialog title="驳回" :visible.sync="dialogVisible" width="28%">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="rulesApi" :model="dialogFormData"
				ref="ruleForm">
				<el-form-item label="驳回原因：" prop="cause">
					<el-input clearable size="small" placeholder="请输入" v-model="dialogFormData.cause"></el-input>
				</el-form-item>
				<div class="card-bottom flex_end">
					<el-button @click="closeDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmDialog('ruleForm')" size="medium">确认</el-button>
				</div>
			</el-form>
		</el-dialog>
		<el-image ref="elImage" style="width: 0; height: 0;" :src="bigImageUrl" :preview-src-list="logicImageList">
		</el-image>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 表格查询条件
				queryData: {
					companyName: '',
					appName: '',
					examineStatus: ''
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				bigImageUrl: '',
				logicImageList: [],
				
				dialogVisible: false,
				rulesApi: {
					cause: [{required: true,message: '请输入驳回原因',trigger: 'blur'}]
				},
				dialogFormData: {},
				
				auditInfoDialogVisible: false,
				auditInfoDialogFormData: {},
				
				auditHistoryVisible: false,
				
				historyData: [],
			}
		},
		activated(){
			if (this.$route.query.keyword) {
				this.queryData.appName = this.$route.query.keyword
			}
			this.getTableData();
		},
		mounted() {
			
		},
		watch: {
			'$route.query.keyword': {
				handler(newKeyword, oldKeyword) {
					// 只有 keyword 变化时才刷新
					if (newKeyword !== oldKeyword) {
						this.queryData.appName = newKeyword
						this.getTableData();
					}
				},
				immediate: true
			}
		},
		methods: {
			// 获取table数据
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					isCheckOrder: true
				}
				data = {
					...data,
					...this.queryData
				}
				let res = await this.$http.post(this.$api.approval.appAuditList, data);
				this.tableData = res.data.list
				this.total = res.data.totalRecord
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			imgPreview(link) {
				// window.open(link, '_blank');
				this.logicImageList = [link]
				this.$nextTick(()=>{
					this.$refs.elImage.clickHandler()
				})
			},
			showApprovalInfo(item){
				this.auditInfoDialogVisible = true
				this.auditInfoDialogFormData = item
			},
			async approvalOperation(type){
				if(type == 3){
					this.dialogVisible = true
				}else{
					let data = {
						examineStatus: type,
						id: this.auditInfoDialogFormData.id
					}
					let res = await this.$http.post(this.$api.approval.appAuditStatus, data);
					if(res.code == 1){
						this.$message.success('审批完成');
						this.closeauditInfoDialog();
						this.getTableData();
					}
				}
			},
			showApprovalHistory(item){
				this.auditHistoryVisible = true
				this.getHistoryList(item);
			},
			async getHistoryList(item){
				let data = {
					pageNum: 1,
					pageSize: 999,
					appId: item.appId
				}
				let res = await this.$http.post(this.$api.approval.appAuditHistoryList, data);
				this.historyData = res.data.list
				// this.total = res.data.totalRecord
			},
			closeDialog(){
				this.dialogVisible = false
				this.dialogFormData = {}
			},
			closeauditInfoDialog(){
				this.auditInfoDialogVisible = false
				this.auditInfoDialogFormData = {}
			},
			closeAuditHistoryDialog(){
				this.auditHistoryVisible = false
			},
			confirmDialog(formName){
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = {
							cause: this.dialogFormData.cause,
							examineStatus: 3,
							id: this.auditInfoDialogFormData.id
						}
						let res = await this.$http.post(this.$api.approval.appAuditStatus, data);
						if(res.code == 1){
							this.$message.success('审批完成');
							this.closeDialog();
							this.closeauditInfoDialog();
							this.closeAuditHistoryDialog();
							this.getTableData();
						}
					}
				});
			},
			// 下载文件
			downloadFile(item) {
				// let a = document.createElement('a')
				// a.href = item
				// a.click();
				window.open(item,'_blank')
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}

	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
		border-radius: 4px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}

	.menu-right {
		margin-left: auto;
		margin-top: 4px;
		/* margin-bottom: 20px; */
	}

	.approvalList {
		background: #ffffff;
		margin-top: 10px;
		padding: 0 16px;
		padding-bottom: 10px;
		border-radius: 4px;
	}
	.approvalLists{
		padding: 0 24px;
		border-top: 1px solid #D5D5D4;
		padding-top: 10px;
		max-height: 560px;
		overflow-y: auto;
	}

	.approvalBox {
		border-bottom: 1px solid #EEEEEE;
		padding-bottom: 20px;
		padding-top: 10px;
	}

	.statusTitle {
		align-items: center;
		margin-bottom: 30px;
	}

	.companyTxt {
		font-weight: 500;
		font-size: 16px;
		color: #333333;
	}

	.statusTxt {
		font-size: 14px;
		color: #FA9600;
	}

	.infoRow {
		align-items: center;
		margin-bottom: 12px;
	}

	.infoTxt {
		font-size: 14px;
		color: #333333;
		font-weight: 500;
		min-width: 20%;
	}

	.infoTxt span {
		font-size: 14px;
		color: #666666;
	}

	.previewBtn {
		padding: 0;
	}
	.approvalTopRow{
		align-items: center;
		border-top: 1px solid #D5D5D4;
		padding: 16px 24px;
	}
	.approvalTitle{
		font-weight: 500;
		font-size: 18px;
		color: #333333;
		margin-bottom: 8px;
	}
	.approvalTips{
		font-weight: 500;
		font-size: 12px;
		color: #999999;
	}
	.el_dialogs /deep/.el-dialog__body{
		padding: 0;
	}
	.dialogSplit{
		background: #F2F5FA;
		height: 12px;
	}
	.dialogContBox{
		padding: 16px 24px;
	}
	.approvalCont{
		font-size: 14px;
		color: #666666;
		margin-bottom: 15px;
	}
	.fileCont{
		align-items: center;
		padding: 0 16px;
		background: #F5F5F5;
		height: 60px;
		border-radius: 4px;
		margin-bottom: 16px;
		margin-top: 4px;
		cursor: pointer;
		width: 50%;
	}
	.fileIcon{
		width: 32px;
		height: 32px;
	}
	.fileName{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		flex-wrap: wrap;
		margin-left: 8px;
	}
	.approvalDialogBottom{
		height: 80px;
		align-items: center;
		padding: 0 24px;
	}
</style>